// Use Icon Hook for handling icons with both SVG and Font Awesome and light/dark mode

import React from 'react';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {IconDefinition, SizeProp} from "@fortawesome/fontawesome-svg-core";
import {useDarkMode as useTheme} from "./useDarkMode";

interface IconProps {
    icon: IconDefinition;
    className?: string;
    size?: SizeProp;
    color?: string;
}

function useIcon({icon, className, size = 'sm', color}: IconProps) {
    const [theme] = useTheme(localStorage.getItem('theme') || 'dark');

    return (
        <FontAwesomeIcon icon={icon}
                         className={`${className} text-${color || theme}-500`}
                         size={size}/>
    );
}

export default useIcon;